// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__C3pMz","modalCard":"styles_modalCard__3iGfY","closeModal":"styles_closeModal__1gl98","modalContent":"styles_modalContent__3YRoj"};